import AccountCardRoot from './AccountCard'
import useViewModel from './useViewModel'

export default function AccountCard() {
  const viewModel = useViewModel()

  return <AccountCardRoot {...viewModel} />
}
